import { useQuery } from "@tanstack/react-query";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import type { TeamNurse } from "../utils/models";
import { departmentRosterQueryOptions } from "./useNurses";
import { teamRosterQueryOptions } from "./useTeamRoster";

/**
 * A department's staff, for views that can show a department other than the chosen one — Management Center in the ops
 * backoffice drill-down. The chosen department reads the shared roster cache, so it adds no request. Any other
 * department reads the Team roster, because `/team/nurses` only serves the departments in the user's token and refuses
 * a support user drilling into another facility.
 */
export const useDepartmentStaff = (departmentId: string): { staff: TeamNurse[] | undefined; isError: boolean } => {
	const { chosenDepartment } = useChosenDepartment();
	const isChosenDepartment = departmentId === chosenDepartment.department_id;
	const rosterQuery = useQuery<TeamNurse[]>({ ...departmentRosterQueryOptions(departmentId), enabled: isChosenDepartment });
	const teamRosterQuery = useQuery<TeamNurse[]>({ ...teamRosterQueryOptions(departmentId), enabled: !isChosenDepartment });
	const query = isChosenDepartment ? rosterQuery : teamRosterQuery;
	return { staff: query.data, isError: query.isError };
};
